import { render, staticRenderFns } from "./allotDialog.vue?vue&type=template&id=276e16ec&scoped=true&"
import script from "./allotDialog.vue?vue&type=script&lang=js&"
export * from "./allotDialog.vue?vue&type=script&lang=js&"
import style0 from "./allotDialog.vue?vue&type=style&index=0&id=276e16ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e16ec",
  null
  
)

export default component.exports